import React from 'react';
import styled from 'styled-components';
import { User } from '../../../context/UserContext';
import { useNavigate } from 'react-router-dom';
import MembershipBadge from '../../components/membership/MembershipBadge';

type Props = {
  open: boolean;
  onClose: () => void;
  user?: any; // 상위에서 내려줄 유저 전체 (뱃지에 전달)
  planGrade?: any; // 'P' | 'S' | 기타
};

const MembershipDescription: React.FC<Props> = ({
  open,
  onClose,
  user,
  planGrade,
}) => {
  const navigate = useNavigate();
  if (!open) return null;

  const isStandard = planGrade === 'S';
  const isPremium = planGrade === 'P';

  // 등급별 카피
  const title = isStandard
    ? '스탠다드 회원은 월간 통계만 이용 가능합니다.'
    : '무료 회원에게만 제공되는 샘플 통계입니다.';

  const desc = '더 많은 통계를 원하신다면 요금제를\n업그레이드해주세요.';

  return (
    <Wrap>
      <Inner>
        <Header>
          <MembershipBadge data={user} />
          <CloseButton onClick={onClose} aria-label="닫기">
            ×
          </CloseButton>
        </Header>
        <Title>{title}</Title>
        <Desc>{desc}</Desc>
        <Bottom>
          <CTA onClick={() => navigate('/payment/plan')}>요금제 둘러보기</CTA>
        </Bottom>
      </Inner>
    </Wrap>
  );
};

export default MembershipDescription;

const Wrap = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 8px;
  background: #fff;
`;

const Header = styled.div`
  display: flex;
  padding: 16px 16px 4px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const LeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.div`
  display: flex;
  padding: 4px 16px;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  font-size: 16px;
  font-weight: 500;
  color: #424854;
`;

const Desc = styled.div`
  display: flex;
  padding: 4px 16px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  font-size: 14px;
  font-weight: 500;
  color: #787d87;
  white-space: pre-line;
`;

const Bottom = styled.div`
  display: flex;
  padding: 8px 16px 16px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
`;

const CTA = styled.button`
  display: flex;
  height: 36px;
  padding: 0 14px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: #3f6ef1;
  color: #f4f5f7;
  font-size: 13px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.26px;
  border: none;
`;

const CloseButton = styled.button`
  border: none;
  background: transparent;
  font-size: 18px;
  color: #6b7280;
  cursor: pointer;
`;
